export default "__VITE_ASSET__AmaaXwWj__"